import Text from "../../components/Text";
import { Button } from "../../components/ui/button.tsx";
import { SquarePenIcon } from "lucide-react";
import { useState, type FC } from "react";
import EditProfile from "./components/EditProfile";
import { userState } from "@/store/userState.ts";
import { useTranslation } from "react-i18next";

type IDefaultValueAndType = {
  type: "fullname" | "oldPassword" | "email";
  defaultValue?: string;
  open: boolean;
};

const DEFAULT_VALUE_AND_TYPE: IDefaultValueAndType = {
  type: "fullname",
  defaultValue: "",
  open: false,
};

const Profile: FC = () => {
  const { t } = useTranslation();

  const [defaultValueAndType, setDefaultValueAndType] =
    useState<IDefaultValueAndType>(DEFAULT_VALUE_AND_TYPE);
  const { data: userData } = userState();

  const isOthersAuthProvider = Boolean(userData?.identities);

  return (
    <>
      <EditProfile
        {...defaultValueAndType}
        onClose={() => setDefaultValueAndType(DEFAULT_VALUE_AND_TYPE)}
      />

      <div
        style={{ height: "calc(100vh - var(--height-header)" }}
        className="bg-[#F7F8F9] p-[16px] sm:p-[24px] flex flex-col overflow-y-auto"
      >
        <Text fontSize={24} fontWeight={600} className="mb-[16px]">
          {t("profil")}
        </Text>
        <div className="flex flex-col gap-[12px]">
          <div className="bg-[white] w-full sm:w-[40%] flex justify-between py-[12px] px-[16px] rounded-[12px]">
            <div className="flex flex-col gap-[8px]">
              <Text fontSize={12} fontWeight={400}>
                {t("fullname")}
              </Text>
              <Text fontSize={16} fontWeight={400}>
                {userData?.name ?? ""}
              </Text>
            </div>
            {!isOthersAuthProvider && (
              <Button
                variant="secondaryFilled"
                size="icon"
                onClick={() => {
                  setDefaultValueAndType({
                    type: "fullname",
                    defaultValue: userData?.name ?? "",
                    open: true,
                  });
                }}
              >
                <SquarePenIcon />
              </Button>
            )}
          </div>

          <div className="bg-[white] w-full sm:w-[40%] flex justify-between py-[12px] px-[16px] rounded-[12px]">
            <div className="flex flex-col gap-[8px]">
              <Text fontSize={12} fontWeight={400}>
                {t("email")}
              </Text>
              <Text fontSize={16} fontWeight={400}>
                {userData?.email ?? ""}
              </Text>
            </div>
            {!isOthersAuthProvider && (
              <Button
                variant="secondaryFilled"
                size="icon"
                onClick={() => {
                  setDefaultValueAndType({
                    type: "email",
                    defaultValue: userData?.email ?? "",
                    open: true,
                  });
                }}
              >
                <SquarePenIcon />
              </Button>
            )}
          </div>

          {!isOthersAuthProvider && (
            <div className="bg-[white] w-full sm:w-[40%] flex justify-between py-[12px] px-[16px] rounded-[12px]">
              <div className="flex flex-col gap-[8px]">
                <Text fontSize={12} fontWeight={400}>
                  {t("password")}
                </Text>
                <Text fontSize={16} fontWeight={400}>
                  **********
                </Text>
              </div>
              {!isOthersAuthProvider && (
                <Button
                  variant="secondaryFilled"
                  size="icon"
                  onClick={() => {
                    setDefaultValueAndType({
                      type: "oldPassword",
                      defaultValue: "",
                      open: true,
                    });
                  }}
                >
                  <SquarePenIcon />
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;
